import type { SVGProps } from 'react';

interface AlertIconProps extends SVGProps<SVGSVGElement> {
    color?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
}

const AlertIcon = ({
    color = 'currentColor',
    width = 52,
    height = 52,
    className,
    ...props
}: AlertIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 52 52"
            fill="none"
            className={className}
            {...props}
        >
            <rect
                x="25.7488"
                y="2.41421"
                width="33"
                height="33"
                rx="5"
                transform="rotate(45 25.7488 2.41421)"
                stroke={color}
                strokeWidth="2"
            />
            <rect x="25.5002" y="17.5" width="1" height="11" stroke={color} />
            <rect x="25.5002" y="32.5" width="1" height="1" stroke={color} />
        </svg>
    );
};

export default AlertIcon;
